import { render, staticRenderFns } from "./_Info.vue?vue&type=template&id=673a87f0&scoped=true&"
import script from "./_Info.vue?vue&type=script&lang=js&"
export * from "./_Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a87f0",
  null
  
)

export default component.exports